import { initClickStack } from "@/clickstack";
import { initPostHog } from "@/posthog";

initClickStack();
initPostHog();
